/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

console.log('Script starting');
window.PXUTheme.jsJpcJukeboxStripUpsell = {
  init: function($section) {
    console.log('Init function called');
    
    try {
      // Get the section ID
      const sectionId = $section.data('section-id');
      console.log('Section ID:', sectionId);
      
      // Find the section data using the section ID
      const $sectionData = $(`script[data-section-id="${sectionId}"][data-section-data]`);
      console.log('Section data element:', $sectionData);
      
      if ($sectionData.length) {
        const sectionData = JSON.parse($sectionData.html());
        console.log('Parsed section data:', sectionData);
        
        // Extend the object with section data
        window.PXUTheme.jsJpcJukeboxStripUpsell = $.extend(this, sectionData);
        
        console.log('Extended object:', this);
        console.log('Jukebox strip product:', this.jukebox_strip_product);
        
        this.$section = $section;
        this.$priceSpan = $('#jukebox-strip-variant-price');
        this.$button = $('#jukebox-strip-button');
        
        // Check if we have the product data
        if (this.jukebox_strip_product) {
          this.product = this.jukebox_strip_product;
          console.log("strips per page", this.stripsPerPage)
          console.log('Product set:', this.product);
          
          // Initialize the upsell
          this.initializeJukeboxStripUpsell();
          this.bindEvents();
        } else {
          console.error('No jukebox strip product data found in section');
        }
      } else {
        console.error('No section data found for section ID:', sectionId);
      }
    } catch (error) {
      console.error('Error in init function:', error);
    }
  },

  initializeJukeboxStripUpsell: function() {
    console.log('Initializing jukebox strip upsell');
    this.updateJukeboxStripUpsell();
  },

  bindEvents: function() {
    console.log('Binding events');
    // Handle jukebox strip add to cart
    this.$button.on('click', (e) => {
      e.preventDefault();
      this.addJukeBoxStripToCart();
    });

    // Listen for cart updates
    $(document).on('cart:updated', () => {
      this.updateJukeboxStripUpsell();
    });

    // Also update when cart drawer is opened/closed
    $(document).on('ajaxCart.afterCartLoad', () => {
      this.updateJukeboxStripUpsell();
    });

    // Listen for cart item removal
    $(document).on('click', '.cart__remove-btn', (e) => {
      console.log('Cart item removal detected');
      // Wait for the item to be removed from cart
      setTimeout(() => {
        this.updateJukeboxStripUpsell();
      }, 500); // Small delay to ensure cart is updated
    });
  },

  // Function to get cart item_count excluding jukebox strip
  getCartItemsCount: function() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: (cart) => {
          // Find jukebox strip item if it exists
          const count = cart.items.filter(item => item.product_type !== "Not a Record" ).length || cart.item_count;
          console.log("cart in jukebox strips", count, cart);          
          
          resolve(count);
        },
        error: (error) => {
          console.error('Error getting cart count:', error);
          reject(error);
        }
      });
    });
  },
  
  // Function to check if jukebox strip is in cart
  checkJukeboxStripInCart: function() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: (cart) => {
          const jukeboxStripItem = cart.items.find(item => 
            item.product_id === this.product.id
          );
          resolve({
            jukeboxStripItem,
            isOnlyItem: cart.items.every(item => item.product_type == "Not a Record")
          });
        },
        error: (error) => {
          console.error('Error checking jukebox strip in cart:', error);
          reject(error);
        }
      });
    });
  },

  // Function to remove jukebox strip from cart
  removeJukeboxStripFromCart: function(variantId) {
    console.log('Removing jukebox strip from cart', variantId);
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          updates: {
            [variantId]: 0
          }
        }),
        success: (cart) => {
          // If cart is empty after removing jukebox strip, clear it
          if (cart.item_count === 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/clear.js',
              dataType: 'json',
              success: () => {
                console.log('Cart cleared');
                window.location.reload();
              },
              error: (error) => {
                console.error('Error clearing cart:', error);
                reject(error);
              }
            });
          } else {
            window.location.reload();
          }
        },
        error: (error) => {
          console.error('Error removing jukebox strip from cart:', error);
          reject(error);
        }
      });
    });
  },

  // Function to update jukebox strip upsell display
  updateJukeboxStripUpsell: async function() {
    console.log('Updating jukebox strip upsell display');
    try {
      const count = await this.getCartItemsCount();
      const correctQuantity = Math.ceil(count/this.stripsPerPage)

      // Check if jukebox strip is in cart
      const { jukeboxStripItem, isOnlyItem } = await this.checkJukeboxStripInCart();

      console.log('Jukebox Strip item:', jukeboxStripItem);
      console.log('Is only item:', isOnlyItem);
      console.log('Current cart total:', count);

      if (!jukeboxStripItem && count <= 0) {
        this.$section.hide();
        console.log('Hiding section - cart count is 0');
        return;
      } else if (jukeboxStripItem && count <= 0) {
        // If count and jukebox strip is in cart, remove it
        await this.removeJukeboxStripFromCart(jukeboxStripItem.variant_id);
        return;
      }

      if (jukeboxStripItem) {
        if (isOnlyItem) {
          // If jukebox strip is the only item, remove it and hide section
          await this.removeJukeboxStripFromCart(jukeboxStripItem.variant_id);
        } else if (jukeboxStripItem.quantity === correctQuantity) {
          // Correct jukebox strip is in cart
          this.$section.hide();
          console.log('Hiding section - correct jukebox strip quantity in cart');
        } else {
          // Wrong jukebox strip product in cart, update to correct variant
          await this.updateJukeboxStripInCart(jukeboxStripItem.variant_id, correctQuantity);
        }
      } else {
        // No jukebox strip in cart
        this.$section.show();
        this.$priceSpan.text("$" + ((this.product.price * correctQuantity) / 100).toFixed(2).replace(/\.00$/, ''));
        console.log('Showing section - no jukebox strip in cart');
      }
    } catch (error) {
      console.error('Error updating jukebox strip upsell:', error); 
    }
  },

  // Handle adding jukebox strip to cart
  addJukeBoxStripToCart: function() {
    const variantId = this.product.variants[0].id;
    console.log('Adding jukebox strip to cart, variant ID:', variantId);
    this.getCartItemsCount().then(count => {
      return Math.ceil(count/this.stripsPerPage)
    }).then(correctQuantity => {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          items: [{
            id: variantId,
            quantity: correctQuantity
          }]
        }),
        success: (response) => {
          console.log('jukebox strip added to cart successfully');
          window.location.reload();
        },
        error: (error) => {
          console.error('Error adding jukebox strip to cart:', error);
          if (error.status === 422) {
            alert('Sorry, the jukebox strip is currently not available. Please try a different option.');
          } else {
            alert('There was an error adding the jukebox strip to your cart. Please try again.');
          }
        }
      });
    }).catch(error => {
      console.error("error in adding jukebox strip", error)
    });
    


  },

  // Function to update Jukebox strip quantity in cart
  updateJukeboxStripInCart: function(variantId, quantity) {
    console.log('Updating Jukebox strip quantity in cart');
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          updates: {
            [variantId]: quantity,
          }
        }),
        success: (cart) => {
          console.log('Jukebox strip quantity updated successfully');
          window.location.reload();
          resolve(cart);
        },
        error: (error) => {
          console.error('Error updating Jukebox strip quantity:', error);
          reject(error);
        }
      });
    });
  },

  unload: function($section) {
    console.log('Unloading section');
    // Clear event listeners
    this.$button.off();
    $(document).off('cart:updated');
    $(document).off('ajaxCart.afterCartLoad');
  }
};

// Wait for jQuery and theme to be ready
console.log('Checking for PXUTheme and jQuery');
console.log('PXUTheme exists:', typeof window.PXUTheme !== 'undefined');
console.log('jQuery exists:', typeof $ !== 'undefined');

if (typeof window.PXUTheme !== 'undefined' && typeof window.PXUTheme.jsJpcJukeboxStripUpsell !== 'undefined') {
  console.log('Theme and module exist, setting up event listeners');
  
  // Initialize on document ready
  $(document).ready(function() {
    console.log('Document ready');
    const sections = $('[data-section-type="jpC-cart__jukebox-strip-upsell"]');
    console.log('Found sections:', sections.length);
    
    sections.each(function() {
      console.log('Initializing section');
      window.PXUTheme.jsJpcJukeboxStripUpsell.init($(this));
    });
  });

  // Initialize on section load (for theme editor)
  $(document).on('shopify:section:load', function(event) {
    console.log('Section load event');
    const $section = $(event.target);
    if ($section.is('[data-section-type="jpC-cart__jukebox-strip-upsell"]')) {
      window.PXUTheme.jsJpcJukeboxStripUpsell.init($section);
    }
  });

  // Cleanup on section unload (for theme editor)
  $(document).on('shopify:section:unload', function(event) {
    console.log('Section unload event');
    const $section = $(event.target);
    if ($section.is('[data-section-type="jpC-cart__jukebox-strip-upsell"]')) {
      window.PXUTheme.jsJpcJukeboxStripUpsell.unload($section);
    }
  });
} else {
  console.log('Theme or module not found');
}

/******/ })();